import { BaseService } from './base.service';

export interface ActionableInsight {
  _id: string;
  id: string;
  memberId: string;
  familyId: string;
  documentId: string;
  type: string;
  value: any;
  summary: string;
  source: string;
  category: string;
  createdAt: string;
  updatedAt: string;
}

export interface ActionableInsightResponse {
  success: boolean;
  data: ActionableInsight[];
  message: string;
}

class ActionableInsightsService extends BaseService {
  constructor() {
    super('/actionable-insights');
  }

  async getInsightsByDocument(documentId: string): Promise<ActionableInsightResponse> {
    try {
      const response = await this.get<ActionableInsightResponse>(`/document/${documentId}`);
      return response;
    } catch (error: any) {
      console.error('Error fetching document insights:', error);
      throw error;
    }
  }

  async getInsightsByMember(memberId: string): Promise<ActionableInsightResponse> {
    try {
      const response = await this.get<ActionableInsightResponse>(`/member/${memberId}`);
      return response;
    } catch (error: any) {
      console.error('Error fetching member insights:', error);
      throw error;
    }
  }

  async getHealthSummary(memberId: string, type?: string): Promise<ActionableInsightResponse> {
    try {
      const url = type 
        ? `/health-summary/${memberId}?type=${type}`
        : `/health-summary/${memberId}`;
      const response = await this.get<ActionableInsightResponse>(url);
      return response;
    } catch (error: any) {
      console.error('Error fetching health summary:', error);
      throw error;
    }
  }
}

export default new ActionableInsightsService();
